import React from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';
import Loader from '../loader';

const Alerts = (props) => {
  const {
    title,
    msg,
    showCancel,
    inputStyles,
    confirmBtnText,
    cancelBtnText,
    onConfirm,
    onCancel,
    btn1Style,
    btn2Style,
    disableYes,
  } = props;
  return (
    <SweetAlert
      custom
      onConfirm={onConfirm}
      onCancel={onCancel}
      showCancel={showCancel}
      title={title ? title : ''}
      style={inputStyles}
      closeOnClickOutside={false}
      allowEscape={false}
      customButtons={
        <React.Fragment>
          {showCancel ? (
            <button className="mr-2" onClick={onCancel} style={btn2Style}>
              {cancelBtnText}
            </button>
          ) : null}
          {disableYes ? (
            <Loader />
          ) : (
            <button onClick={onConfirm} style={btn1Style}>
              {confirmBtnText}
            </button>
          )}
        </React.Fragment>
      }
    >
      {msg}
    </SweetAlert>
  );
};

export default Alerts;
